import { FaYoutube, FaDownload } from "react-icons/fa";

// ---------------------------------------------------------
// Fill in the real YouTube link once you have it - this is the
// only line you need to touch when it's ready.
// ---------------------------------------------------------
const TUTORIAL_URL = "https://www.youtube.com/@TrovaSolarWifiDongle";

// Matches the nginx setup from the OTA/download-hosting guide -
// serves the APK with Content-Disposition: attachment so it starts
// downloading immediately instead of opening in-browser.
const APP_DOWNLOAD_URL = "https://trovawifidongle.com/downloads/Trova_Wifi_App.apk";

// Drop <LoginExtraLinks /> into Login.jsx - see the placement note
// in the accompanying instructions for exactly where.
export default function LoginExtraLinks() {

    return (

        <div className="loginExtraLinks">

            <a
                href={TUTORIAL_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="loginExtraBtn tutorial"
            >
                <FaYoutube /> Tutorial
            </a>

            <a
                href={APP_DOWNLOAD_URL}
                download
                className="loginExtraBtn download"
            >
                <FaDownload /> Download App
            </a>

        </div>

    );

}
